import { render, staticRenderFns } from "./applybillDetail.vue?vue&type=template&id=0837ef0c&"
import script from "./applybillDetail.vue?vue&type=script&lang=js&"
export * from "./applybillDetail.vue?vue&type=script&lang=js&"
import style0 from "./applybillDetail.vue?vue&type=style&index=0&id=0837ef0c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports